function pdpCustomDropdownInit () {
    document.querySelectorAll('[js-custom-option-select]').forEach(function(selectElement) {
          var numberOfOptions = selectElement.children.length;
          var optionName = selectElement.dataset.optionName;
          if (optionName) {
              optionName = optionName + ' : ';
          } else {
              optionName = '';
          }
     
          selectElement.style.display = 'none';
     
          var wrapper = document.createElement('div');
          wrapper.className = 'select';
          selectElement.parentNode.insertBefore(wrapper, selectElement);
          wrapper.appendChild(selectElement);
     
          var styledSelect = document.createElement('div');
          styledSelect.className = 'select-styled';
          var selectedText = selectElement.querySelector('option[selected]') ?
              selectElement.querySelector('option[selected]').textContent :
              selectElement.options[selectElement.selectedIndex].textContent;
     
          styledSelect.innerHTML = `${optionName}${selectedText}<div class="select-styled-icon">
              <svg width="14" height="7" viewBox="0 0 14 7" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2L7 6L2 2" stroke="black" stroke-width="1.5" stroke-linecap="square"/>
              </svg>
              </div>`;
             
          wrapper.appendChild(styledSelect);
     
          var list = document.createElement('ul');
          list.className = 'select-options';
          wrapper.appendChild(list);
     
          for (var i = 0; i < numberOfOptions; i++) {
              var listItem = document.createElement('li');
              listItem.textContent = selectElement.children[i].textContent;
              listItem.setAttribute('rel', selectElement.children[i].value);
              list.appendChild(listItem);
     
              if (selectElement.children[i].selected) {
                  listItem.classList.add('is-selected');
              }
          }
     
          var listItems = list.children;
     
          styledSelect.addEventListener('click', function(e) {
              e.stopPropagation();
              document.querySelectorAll('div.select-styled.active').forEach(function(activeStyledSelect) {
                  if (activeStyledSelect !== styledSelect) {
                      activeStyledSelect.classList.remove('active');
                      activeStyledSelect.nextElementSibling.style.display = 'none';
                  }
              });
              styledSelect.classList.toggle('active');
              list.style.display = styledSelect.classList.contains('active') ? 'block' : 'none';
          });
     
          Array.from(listItems).forEach(function(listItem) {
              listItem.addEventListener('click', function(e) {
                  e.stopPropagation();
     
                  let optionName = styledSelect.closest('.select').querySelector('select').dataset.optionName;
                  if (optionName) {
                      optionName = optionName + ' : ';
                  } else {
                      optionName = '';
                  }
                  styledSelect.innerHTML = `${optionName}${listItem.textContent}<div class="select-styled-icon">
                      <svg width="14" height="7" viewBox="0 0 14 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 2L7 6L2 2" stroke="black" stroke-width="1.5" stroke-linecap="square"/>
                      </svg>
                    </div>`;
     
                  styledSelect.classList.remove('active');
                  list.style.display = 'none';
     
                  selectElement.value = listItem.getAttribute('rel');
     
                  let selected = list.querySelector('li.is-selected');
                  if (selected) selected.classList.remove('is-selected');
                  listItem.classList.add('is-selected');
                  selectElement.dispatchEvent(new Event('change', { 'view': window, 'bubbles': true }));
              });
          });
     
          document.addEventListener('click', function() {
              styledSelect.classList.remove('active');
              list.style.display = 'none';
          });
          styledSelect.classList.remove('active');
          list.style.display = 'none';
    });
}
pdpCustomDropdownInit()
document.addEventListener('pdpCustomDropdown:init',pdpCustomDropdownInit)